// test2534
(2534 && 0);
